import { css, Theme } from '@emotion/react'

type Props = {
  comment: string
}

export const CommentLeft: React.FC<Props> = ({ comment }) => {
  return (
    <>
      <article css={styles.container}>
        <span css={[styles.linetop, styles.line]}></span>
        <span css={[styles.lineright, styles.line]}></span>
        <span css={[styles.linebottom, styles.line]}></span>
        <span css={[styles.lineleft, styles.line]}></span>
        <h2 css={styles.text}>{comment}</h2>
      </article>
    </>
  )
}

const styles = {
  container: css`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    max-width: 1000px;
    width: 80vw;
    height: 150px;
    margin: 0 auto 30px;
    &:before {
      content: '';
      background-image: url('/frame_2.svg');
      stroke: white;
      background-size: cover;
      position: absolute;
      width: 50px;
      height: 35px;
      left: -49px;
      bottom: 0;
    }
    @media (max-width: 768px) {
      width: 80vw;
      height: 100px;
      &:before {
        background-image: url('/frame_4.svg');
        transform: scale(0.5);
        left: -37px;
        bottom: -8.5px;
      }
    }
  `,
  line: (theme: Theme) => css`
    position: absolute;
    background-color: ${theme.palette.primary.main};
  `,
  linetop: css`
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
  `,
  lineright: css`
    right: 0;
    top: 0;
    bottom: 0px;
    width: 1px;
  `,
  linebottom: css`
    bottom: 0;
    right: 0;
    left: 0;
    height: 1px;
  `,
  lineleft: css`
    left: 0;
    top: 0;
    bottom: 34px;
    width: 1px;
    @media (max-width: 768px) {
      bottom: 17px;
    }
  `,
  text: (theme: Theme) => css`
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 1.6rem;
    color: ${theme.palette.primary.main};
    padding: 0 40px;
    @media (max-width: 768px) {
      font-size: 0.7rem;
      padding: 0 30px;
    }
  `,
}
